import moment from 'moment'
import SvgCheckDoubleOutlined from '@/assets/svgs/status/check-double-outlined.jsx'
import SvgXCircleSolid from '@/assets/svgs/status/x-circle-solid.jsx'
import SvgArrowUpCircleOutlined from '@/assets/svgs/status/arrow-up-circle-outlined.jsx'
import SvgCheckHistoryOutlined from '@/assets/svgs/status/check-history-outlined.jsx'

const META = {
  SUBMITTALS_CREATED: {
    heading: 'Submission Created',
    icon: <SvgCheckHistoryOutlined className="DS__icon--warning" />,
  },
  SUBMITTALS_DRAFTED: {
    heading: 'Draft Saved',
    icon: <SvgCheckHistoryOutlined className="DS__icon--warning" />,
  },
  SUBMITTALS_UPDATED: {
    heading: 'Submission Updated',
    icon: <SvgArrowUpCircleOutlined className="DS__icon--info" />,
  },
  APPROVER_UPDATED: {
    heading: 'Approver Updated',
    icon: <SvgArrowUpCircleOutlined className="DS__icon--info" />,
  },
  SUBMITTALS_APPROVED: {
    heading: 'Submission Approved',
    icon: <SvgCheckDoubleOutlined className="DS__icon--success" />,
  },
  SUBMITTALS_REJECTED: {
    heading: 'Submission Rejected',
    icon: <SvgXCircleSolid className="DS__icon--error" />,
  },
  SUBMITTALS_REPLACED: {
    heading: 'Submission Replaced',
    icon: <SvgXCircleSolid className="DS__icon--error" />,
  },
  SUBMITTALS_DELETED: {
    heading: 'Submission Deleted',
    icon: <SvgXCircleSolid className="DS__icon--error" />,
  },
  SUBMITTALS_PASSED_DEADLINE: {
    heading: 'Submission Passed Deadline',
    icon: <SvgXCircleSolid className="DS__icon--error" />,
  },
}

export const buildLogEntries = (logs = []) =>
  logs.map((log, idx) => {
    const meta = META[log.activity] || { heading: log.activity, icon: null }
    const actor = log.consultant?.email || log.consultant?.name || log.user?.email
    const ts = log.created ? moment(log.created).format('DD/MM/YYYY, h:mm A') : ''
    return {
      id: log.id ?? idx,
      icon: meta.icon,
      heading: meta.heading,
      details: log.message ? [{ label: 'Reason', value: log.message }] : undefined,
      meta: [actor && `by ${actor}`, ts && `on ${ts}`].filter(Boolean).join(' '),
    }
  })
